import logo from "../images/logo.png";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { API_BASE } from "core/Constants";
import axios from "axios";
import "animate.css";

const ResetPassword = props => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();

    const query = new URLSearchParams(window.location.search);
    const _st = query.get("st"); //time
    const _su = query.get("su"); //email
    const _ref = query.get("ref");
    console.log("timestamp", _st);

    if (password === "") {
      toast.error("Passwords is required");
      return;
    } else if (confirmPassword === "") {
      toast.error("Confirm password is required");
      return;
    } else if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setLoading(true);

    let opts = {
      method: "post",
      url: `${API_BASE}/reset-password`,
      data: { emailid: _su, password: confirmPassword, ref: _ref, ts: _st },
    };

    axios(opts)
      .then(async res => {
        console.log(res);
        if (res.status === 200) {
          toast.success("Password updated successfully");
          setPassword("");
          setConfirmPassword("");
        } else {
          toast.error("Failed to update password");
        }
        setTimeout(() => {
          setLoading(false);
        }, 200);
      })
      .catch(error => {
        console.error(error);
        toast.error(error.response.data.error);
        setLoading(false);
      });
  };
  const navigate = useNavigate();
  return (
    <div id="login">
      <section className="white">
        <div className="logo">
          <img src={logo} alt="SpotTrek" />
        </div>
        <div className="form-wrapper">
          <form onSubmit={handleSubmit}>
            <h2>Reset Password!</h2>
            <p>Please set a new password</p>
            <div className="row">
              <label>Password</label>
              <input
                value={password}
                onChange={e => setPassword(e.target.value)}
                type="password"
                placeholder="New password"
                autoComplete="current-password"
                maxLength={15}
              />
            </div>
            <div className="row">
              <label>Confirm Password</label>
              <input
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                type="password"
                placeholder="Confirm new password"
                autoComplete="confirm-password"
                maxLength={15}
              />
            </div>
            <div className="row">
              {loading ? (
                <div className="lds-roller">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              ) : (
                <button>Update</button>
              )}
            </div>
            <div className="row">
              <p className="forgotpassword" onClick={() => navigate("/login")}>
                &larr;&nbsp;&nbsp;Back to Login
              </p>
            </div>
          </form>
        </div>
        <p className="copy">&copy; BARC India 2024</p>
      </section>
      <Toaster />
    </div>
  );
};

export default ResetPassword;
